<template>
<div class="container-fluid bg-white">
	<service-toolbar></service-toolbar>

	<forms-tab :service-id="'id' in $store.service ? $store.service.id : false" :customer-id="$store.service ? $store.service.customer_id : false"></forms-tab>
</div>
</template>
<script type="text/javascript">
import FormsTab from "@/components/super_components/FormsTab"
import ServiceToolbar from "@/pages/project/services/ServiceToolbar"

import ServiceMixins from "@/mixins/ServiceMixins.js"

export default {
	name: "ServiceForms",
	components: {
		ServiceToolbar,
		FormsTab
	},
	mixins: [ServiceMixins],
	created() {
		this.setServiceIfNotSet()
	}
}
</script>